export var EDIT_PAGE_EMBED = {
  name: 'EDIT_PAGE_EMBED',
  pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
export var EDIT_PAGE_V2 = {
  name: 'EDIT_PAGE_V2',
  pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
export var SPACE_OVERVIEW = {
  name: 'SPACE_OVERVIEW',
  pattern: '/wiki/spaces/:spaceKey/overview'
};
export var VIEW_PAGE = {
  name: 'VIEW_PAGE',
  pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
export var VIEW_BLOG = {
  name: 'VIEW_BLOG',
  pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
export var VIEW_BLOG_DATE_LEGACY = {
  name: 'VIEW_BLOG_DATE_LEGACY',
  pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
export var WHITEBOARD = {
  name: 'WHITEBOARD',
  pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
export var namedRoutes = {
  EDIT_PAGE_EMBED: EDIT_PAGE_EMBED,
  EDIT_PAGE_V2: EDIT_PAGE_V2,
  SPACE_OVERVIEW: SPACE_OVERVIEW,
  VIEW_PAGE: VIEW_PAGE,
  VIEW_BLOG: VIEW_BLOG,
  VIEW_BLOG_DATE_LEGACY: VIEW_BLOG_DATE_LEGACY,
  WHITEBOARD: WHITEBOARD
};
export var EMBEDDED_PARENT_PRODUCTS = {
  JSM_PORTAL: 'JSM-Portal',
  JSM: 'JSM',
  JSW: 'JSW',
  JWM: 'JWM'
};